import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PublicationApproved')
export class PublicationApproved {
  @JsonProperty('id', Number, true) id: number = undefined;
  @JsonProperty('approvedDate', String, true) approvedDate: string = undefined;
  @JsonProperty('price', Number, true) price: number = undefined;
  @JsonProperty('email', String, true) email: string = undefined;
}
